// Sentry for the slim apex wiki head (wiki.js), fetched only once something goes wrong.
// The SDK was 51 KB of wiki.js's 66 KB gzip, on the most-visited pages, to report about
// fourteen errors in 90 days across all six brands (2026-10-27). Until the first error two
// listeners keep every error and rejection; that error imports ./sentry (the same setup as
// learn.*) as a chunk of its own, whose init installs Sentry's window.onerror and
// window.onunhandledrejection. The kept events go through those two exactly as the browser
// would have passed them, so they report unhandled, filtered and grouped as before. Only the
// breadcrumbs from before the first error are lost.
const kept = []
let loading = null

const keep = (event) => {
  kept.push(event)
  loading ||= import("./sentry")
    .then(() => {
      window.removeEventListener("error", keep)
      window.removeEventListener("unhandledrejection", keep)
      kept.splice(0).forEach((keptEvent) => {
        if (keptEvent.type === "unhandledrejection") {
          window.onunhandledrejection?.(keptEvent)
        } else {
          const { message, filename, lineno, colno, error } = keptEvent
          window.onerror?.(message, filename, lineno, colno, error)
        }
      })
    })
    .catch(() => {})
}

window.addEventListener("error", keep)
window.addEventListener("unhandledrejection", keep)
